import { render, staticRenderFns } from "./reclamo.vue?vue&type=template&id=4e453a9e&"
import script from "./reclamo.vue?vue&type=script&lang=ts&"
export * from "./reclamo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports